import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import InfoItem from './InfoItem';

import { getI18n } from '@/utils/i18n';

import styles from './JobInfo.cm.styl';

const cx = classNames.bind(styles);

const i18n = getI18n();
function JobInfo({ infoItems, itemPerRow = 2 }) {
  const rowStyle = itemPerRow === 2 ? styles.infoRow2 : styles.infoRow3;
  return (
    <div className={styles.infoContainer}>
      <div className={styles.infoTitle}>
        {i18n.t`职位信息`}
        <div className={styles.hr} />
      </div>
      <div className={cx('infoBody', { spaceBetween: itemPerRow === 2 })}>
        {infoItems.map(({ name, type, value }) => (
          <div key={name} className={rowStyle}>
            <InfoItem name={name} value={value} keepWhiteSpace={type === 'text_info'} />
          </div>
        ))}
      </div>
    </div>
  );
}

JobInfo.propTypes = {
  infoItems: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
    })
  ),
  itemPerRow: PropTypes.number, // headhunters show 3 items per row, apply-web show 2 items per row
};

export default JobInfo;
